import { EudrAnmalanDto } from "~app/features/planera/model/EudrAnmalanDto";

export class EudrAnmalanVM {
    skickad?: Date;
    kvitterad?: Date;
    status?: string;
    gallande?: boolean;
    referens?: string;
    errors?: string[];
    identifierare?: string;
    verifiering?: string;

    constructor(dto: EudrAnmalanDto) {
        this.skickad = dto.skickad ? new Date(dto.skickad) : null;
        this.kvitterad = dto.kvitterad ? new Date(dto.kvitterad) : null;
        this.gallande = dto.gallande;
        this.referens = dto.referens;
        this.status = dto.status;
        this.errors = dto.errors;
        this.identifierare = dto.identifierare;
        this.verifiering = dto.verifiering;
    }
}
